@app.controller 'matrixFormController', (ComponentService) ->
  @itemTypeOptions = ['Media', 'List', 'Circle', 'Popup', 'Icon', 'Card']
  @resourceTypeOptions = ['Class', 'Activity']

  @applyClass = =>
    matrixClass = []
    matrixClass.push "matrix-#{@columns}-col"

    matrixClass.push "matrix-#{@itemType.toLowerCase()}"
    matrixClass.join ' '

  @setItem = (selectedItem, currentItem) ->
    console.log 'setting item'
    angular.forEach currentItem.content, (value, key) ->
      if selectedItem.hasOwnProperty(key)
        currentItem.content[key] = selectedItem[key]

  @setNumItems = =>
    @numItems = @rows * @columns
    @deltaItems = angular.copy @items unless @deltaItems
    delta = @numItems - @deltaItems.length
    matrixItem = ComponentService.newItem('matrix')

    # If there are not enough items, then add new items
    if delta > 0
      _.times delta, =>
        newMatrixItem = angular.copy matrixItem
        @items.push newMatrixItem

     # Only keep the items needed
    if delta < 0
      @items = @deltaItems.slice(0, @numItems)

  @deltaItems = angular.copy @items
  this

@app.directive 'matrixForm', (ComponentService) ->
  restrict: 'E'
  scope: {}
  controller: 'matrixFormController'
  controllerAs: 'matrix'

  bindToController: {
    items: '='
    rows: '='
    columns: '='
    itemType: '='
    theme: '='
    descriptionCharLimit: '='
    resourceType: '='
  }

  templateUrl: "/assets/templates/components/matrix/matrixForm.html"
